var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQuery } from '@tanstack/react-query';
import { profileDetailsCacheKey } from 'syf-api/api/cacheKeys';
import { fetchConfig } from '../../helpers';
import ENDPOINTS from '../../const/endpoints';
import store from '../../helpers/store';
import { STORE_KEYS } from '../../const/store-keys';
function useProfileQuery(_a) {
    var config = _a.config, keyProps = _a.keyProps, _b = _a.queryOptions, queryOptions = _b === void 0 ? {} : _b;
    var fetchWrapper = fetchConfig(config);
    return useQuery(__assign({ queryKey: profileDetailsCacheKey(keyProps), queryFn: function () {
            var params = new URLSearchParams({
                'cipher.accountId': keyProps.accountId,
                accountIdType: keyProps.accountIdType
            });
            var isFetchProfileHeaders = store.get(STORE_KEYS.isProfileEnabled, 'session') || false;
            return fetchWrapper("".concat(ENDPOINTS.profile, "?").concat(params), {
                method: 'GET',
                headers: !isFetchProfileHeaders
                    ? {
                        'X-syf-Expect': '100-continue',
                        'X-syf-Unmasked-Data': 'true'
                    }
                    : {}
            });
        } }, queryOptions));
}
export default useProfileQuery;
